<div class="fluid grid ">
  <div class="p-flex-row col-12">
    <p-progressSpinner *ngIf="loading" ariaLabel="loading" [style]="{width: '100%', height: '25rem'}" />
    <p-chart *ngIf="!loading" type="bar" [data]="dataDailyPerformance" [options]="dailyPerformanceOptions" (onDataSelect)="selectData($event)" width="100%" height="25rem"></p-chart>
  </div>
</div>
